import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BagQRPrintFiltering } from './Pages';
import { BagQRPrintAdding } from './Pages/adding';

export const BagQRPrintRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={BagQRPrintFiltering} />
        <Route exact path={`${match.path}/add`} component={BagQRPrintAdding} />
    </Fragment>
)